var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-practice practiceAdult" }, [
    _c("div", { staticClass: "box filter-box" }, [
      _c("ul", { staticClass: "filter-list" }, [
        _c("li", { staticClass: "item" }, [
          _c("span", { staticClass: "tit" }, [_vm._v("课程类型")]),
          _c(
            "div",
            { staticStyle: { flex: "1" } },
            _vm._l(_vm.specialtyCount, function (item, index) {
              return _c(
                "el-radio",
                {
                  key: index,
                  staticClass: "radio",
                  attrs: { label: item.course_type },
                  on: { change: _vm.typeChange },
                  model: {
                    value: _vm.courseType,
                    callback: function ($$v) {
                      _vm.courseType = $$v
                    },
                    expression: "courseType",
                  },
                },
                [_vm._v(_vm._s(item.title) + " (" + _vm._s(item.num) + ") ")]
              )
            }),
            1
          ),
        ]),
        _c("li", { staticClass: "item" }, [
          _c("span", { staticClass: "tit" }, [_vm._v("课程选择")]),
          _c(
            "div",
            { staticClass: "con", staticStyle: { "margin-top": "-5px" } },
            _vm._l(_vm.selectlist, function (item) {
              return _c(
                "el-button",
                {
                  key: item.id,
                  staticClass: "course",
                  class: _vm.courseUuid == item.course_id ? "active" : "",
                  attrs: { size: "mini", round: "" },
                  on: {
                    click: function ($event) {
                      return _vm.courseSelect(item)
                    },
                  },
                },
                [_vm._v(_vm._s(item.title))]
              )
            }),
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "content-box" },
      [
        _c("ul", { staticClass: "title-box" }, [
          _vm._m(0),
          _c("li", { staticClass: "total" }, [
            _c("div", [
              _c("span", { staticClass: "gray-light mar10" }, [
                _vm._v("作业完成度"),
              ]),
              _c("span", { staticClass: "f30 lighten-blue" }, [
                _vm._v(_vm._s(_vm.course_info.ratio || 0) + "%"),
              ]),
            ]),
          ]),
        ]),
        _vm._m(1),
        _vm._l(_vm.majorList, function (item) {
          return _c(
            "ComponentCollapse",
            {
              key: item.id,
              ref: "component",
              refInFor: true,
              staticClass: "collapse-box",
              attrs: {
                title: item.title,
                name: item.id,
                activeNames: _vm.activeNames,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "title-right",
                  attrs: { slot: "title-right" },
                  slot: "title-right",
                },
                [_c("el-progress", { attrs: { percentage: item.ratio } })],
                1
              ),
              _vm._l(item.node, function (course) {
                return _c(
                  "ul",
                  {
                    key: course.id,
                    staticClass: "collapse-cell",
                    attrs: { slot: "collapseContent" },
                    slot: "collapseContent",
                  },
                  [
                    _c(
                      "li",
                      { staticClass: "item" },
                      [
                        course.task_status == 2
                          ? _c("i", {
                              staticClass: "iconfont icongouxuan primary",
                            })
                          : _c("el-progress", {
                              staticStyle: {
                                "vertical-align": "middle",
                                "margin-right": "10px",
                              },
                              attrs: {
                                width: 20,
                                strokeWidth: 0,
                                type: "circle",
                                percentage: 0,
                                "show-text": false,
                              },
                            }),
                        _c("span", { staticClass: "span tit" }, [
                          _vm._v(_vm._s(course.title)),
                        ]),
                      ],
                      1
                    ),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(_vm._s(course.last_time || "--")),
                    ]),
                    _c("li", { staticClass: "item" }, [
                      course.task_num > 0 && course.subject_total > 0
                        ? _c("span", [
                            _vm._v(
                              "已做：" +
                                _vm._s(course.fulfil_number || 0) +
                                "/总题：" +
                                _vm._s(course.subject_total || 0)
                            ),
                          ])
                        : _c("span", [_vm._v("--")]),
                    ]),
                    _c(
                      "li",
                      { staticClass: "item" },
                      [
                        course.task_num > 0
                          ? [
                              _c(
                                "span",
                                {
                                  class: _vm.getCourseClass(course.task_status),
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.workStatus[course.task_status])
                                  ),
                                ]
                              ),
                              course.task_status === 0 &&
                              course.learn_status === 1 &&
                              _vm.course_info.is_hours_complete === 1
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "uni-link-btn",
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-video-play",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.jump(
                                            "startPractice",
                                            course
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("做作业")]
                                  )
                                : _vm.course_info.is_hours_complete === 0
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "uni-link-btn",
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-video-play",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.jump(
                                            "startPractice",
                                            course
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("做作业")]
                                  )
                                : course.learn_status === 0 &&
                                  _vm.course_info.is_hours_complete === 1
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "uni-link-btn",
                                      staticStyle: {
                                        background: "#999 !important",
                                      },
                                    },
                                    [_vm._v("未完成学习")]
                                  )
                                : _vm._e(),
                            ]
                          : _c("div", { staticClass: "gray" }, [
                              _vm._v("无作业练习"),
                            ]),
                      ],
                      2
                    ),
                  ]
                )
              }),
            ],
            2
          )
        }),
        _vm.majorList.length == 0
          ? _c("ComponentEmpty", { attrs: { tips: "", title: "暂无作业进度" } })
          : _vm._e(),
        _c("ComponentDialog1", {
          attrs: {
            icon: "fail",
            title: "需完成本章节的课程学习",
            visible: _vm.isDialogVisible,
            cancelText: "返回",
            confirmText: "去学习",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isDialogVisible = $event
            },
            cancel: function ($event) {
              _vm.isDialogVisible = !_vm.isDialogVisible
            },
            confirm: _vm.dialogConfirm,
          },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "title" }, [
      _c("span", { staticClass: "f18" }, [_vm._v("作业进度")]),
      _c("span", { staticClass: "gray-light mal20" }, [
        _vm._v("每个章节的题做完才算作业完成。"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "head-box" }, [
      _c("li", { staticClass: "item" }, [_vm._v("课程名称")]),
      _c("li", { staticClass: "item" }, [_vm._v("上次作业时间")]),
      _c("li", { staticClass: "item" }, [_vm._v("做题情况")]),
      _c("li", { staticClass: "item" }, [_vm._v("操作")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }